import React from 'react';
import heroImage from '../assets/hero.jpeg';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-image-container">
          <img src={heroImage} alt="Tri-Bay Electric professional electrician" className="hero-image" />
        </div>
        <div className="hero-content">
          <div className="hero-text-wrapper">
            <span className="hero-tagline">Industry Leaders Since 1980</span>
            <h1>Expert Electrical<br /><span className="hero-highlight">Contracting Solutions</span></h1>
            <h3>Delivering quality commercial electrical services<br />throughout the San Francisco Bay Area</h3>
            <div className="cta-container">
              <a href="#contact" className="cta-button">Contact Us</a>
              <a href="#services" className="cta-link">View Our Services</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 